module.exports = __webpack_public_path__ + "static/media/create_sections_add_missing_courses_teachers.96afd86f.mov";